// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingResultTableRow-moduleDocFlowMappingResultTableRow__l_qa0 TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowMappingResultTableRow" }
